<template src="./target-public-users.html">
</template>

<script>
  import Vue from 'vue'
  import { EventBus } from '@/router/bus'
  import i18n from '@/i18n'
  import Datepicker from '@/utils/datepicker/'
  import Vuelidate from 'vuelidate'
  import { validationMixin } from '@/mixins/validation'
  import { required } from 'vuelidate/lib/validators'
  import { srCYRL, sr, en } from '@/utils/datepicker/locale'
  import Datatable from '@/components/misc/datatable/Datatable'
  import Loader from '@/components/misc/Loader'
  import Autocomplete from '@/components/misc/autocomplete/Autocomplete'

  Vue.use(Vuelidate)

  export default {
    name: 'target-public-users',
    mixins: [validationMixin],
    components: {
      Datatable,
      Datepicker,
      Autocomplete,
      Loader
    },
    data () {
      return {
        dateFormat: this.$store.getters.dateFormat,
        autoCompleteUrl_budgetId: Vue.$apiConfig.budgetRegistryGet,
        targetPublicUsersReportsUrl: '',
        autoCompletePopover: false,
        autoCompletePopoverItem: {},
        dateLocale: srCYRL,
        load: false,
        targetPublicUsersUrl: '',
        targetPublicUserModel: {
          BudgetUserId: null,
          Name: null
        },
        options: [
          {
            text: i18n.t('userAdministration.notificationPriorityStatus.1'),
            value: 1
          }, {
            text: i18n.t('userAdministration.notificationPriorityStatus.2'),
            value: 2
          }, {
            text: i18n.t('userAdministration.notificationPriorityStatus.3'),
            value: 3
          }
        ],
        tOptions: {
          checkboxes: false,
          payloadsTotalPropertyName: 'additionalInformation'
        },
        tColumns: [
          {
            columnName: 'budgetUserId',
            title: i18n.t('userRegistration.registrationBudgetId'),
            filterType: 'input',
            align: 'center',
            cell (row) {
              return row.budgetUserId
            }
          },
          {
            columnName: 'name',
            title: i18n.t('userRegistration.registrationName'),
            filterType: 'input',
            align: 'right',
            cell (row) {
              return row.name
            }
          }
        ]
      }
    },
    created () {
      this.targetPublicUsersUrl = Vue.$apiConfig.pagedTargetPublicUsersGet
      this.targetPublicUsersReportsUrl = Vue.$config.reporting_api_root + '/' + Vue.$apiConfig.generateTargetPublicUsersReports
    },
    mounted () {
      switch (this.$store.getters.dateLocale) {
        case 'sr-cyrl':
          this.dateLocale = srCYRL
          break
        case 'sr':
          this.dateLocale = sr
          break
        case 'en':
          this.dateLocale = en
          break
        default:
          this.dateLocale = srCYRL
      }
    },
    methods: {
      validateBeforeSubmit () {
        this.logConsole('Creating user notification')

        // validate first
        this.createNotification()
      },
      onRowSelected (row) {
        this.targetPublicUserModel.BudgetUserId = row.budgetUserId
        this.targetPublicUserModel.Name = row.name
        this.$refs.removeTargetBudgetUserModal.show()
      },
      appendTargetBudgetUser () {
        this.load = true
        this.$http.post(Vue.$apiConfig.targetPublicUsersPost, this.targetPublicUserModel)
          .then(response => {
            this.logConsole(response)
            this.load = false
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('userAdministration.targetPublicUsersAppendSuccess'),
              errors: []
            })
            EventBus.$emit('refresh-table')
          }, error => {
            this.logConsole(error)
            this.formatErrorResponse(error)
            this.load = false
          })
      },
      removeTargetBudgetUser () {
        this.load = true
        this.$http.patch(Vue.$apiConfig.targetPublicUsersPatch, this.targetPublicUserModel)
          .then(response => {
            this.logConsole(response)
            this.load = false
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('userAdministration.targetPublicUsersRemoveSuccess'),
              errors: []
            })
            EventBus.$emit('refresh-table')
          }, error => {
            this.logConsole(error)
            this.formatErrorResponse(error)
            this.load = false
          })
      },
      budgetNumberResolved (item) {
        this.targetPublicUserModel.Name = item.cyrilicName
      },
      autocompleteErrorClass () {
        return this.$v.targetPublicUserModel.BudgetUserId.$error ? 'error' : null
      }
    },
    validations: {
      targetPublicUserModel: {
        BudgetUserId: {
          required
        }
      }
    }
  }
</script>
<style lang="scss" type="text/scss" scoped>

  .container {
    padding: 0px;
  }

  @media (min-width: 1400px) {
      .container {
          width: 1360px;
          max-width: 100%;
      }
  }

  @media (min-width: 1680px) {
      .container {
          width: 1640px;
          max-width: 100%;
      }
  }

  @media (min-width: 1920px) {
      .container {
          width: 1860px;
          max-width: 100%;
      }
  }

  @media (min-width: 2560px) {
      .container {
          width: 2460px;
          max-width: 100%;
      }
  }

  @media (min-width: 2880px) {
      .container {
          width: 2620px;
          max-width: 100%;
      }
  }

  @media (min-width: 3840px) {
      .container {
          width: 3550px;
          max-width: 100%;
      }
  }    
  
  .invalid-notification {
    background-color: #f8d7da !important;
  }
  
</style>



// WEBPACK FOOTER //
// TargetPublicUsers.vue?6eb5c780